<template>
  <div>
    <div class="fodown_wrap">
      <!--<div class="fodown_cont">
        <div class="fodown_cont_down">
          <div class="fodown_cont_dleft" style="width: 264px;">
            <div class="fodown_cont_dcdvM" style="width: 264px;">
              <div class="footer_contact_view">
                <div class="footer_contact_top">Nombre de empresa</div>
                <div class="footer_contact_down">YOONATECH, S.A. DE C.V.</div>
              </div>
            </div>
          </div>
          <div class="fodown_cont_dcenter">
            <div class="fodown_cont_dcdv">
              <div class="fodown_cont_dcdvL">
                <div class="fodown_cont_dcdv_solid"></div>
              </div>
              <div class="fodown_cont_dcdvM" @click.stop="openGooglePlayLink">
                <img src="../assets/img/fodown_two.png" />
              </div>
              <div class="fodown_cont_dcdvR">
                <div class="fodown_cont_dcdv_solid"></div>
              </div>
            </div>
          </div>
          <div class="fodown_cont_dcenter" style="width: 362px;">
            <div class="fodown_cont_dcdvM" style="width: 362px;">
                <div class="footer_contact_view">
                  <div class="footer_contact_top">Teléfono:</div>
                  <div class="footer_contact_down">5585266983</div>
                </div>
                <div class="footer_contact_view">
                  <div class="footer_contact_top">Horario::</div>
                  <div class="footer_contact_down">Lunes a viernes 9:00-17.00,</div>
                  <div class="footer_contact_down">sábado 9.00-14.00.</div>
                </div>
            </div>
            <div class="fodown_cont_dcdvR">
              <div class="fodown_cont_dcdv_solid"></div>
            </div>
          </div>
          <div class="fodown_cont_dright">
            <div class="fodown_cont_drdv">
              <div class="fodown_cont_drdv_top">
                <div class="fodown_cont_drdv_tL">
                  <img src="../assets/img/fodown_thr.png" />
                </div>
                <div class="fodown_cont_drdv_tR">Correo para quejas de cobranza</div>
              </div>
              <div class="fodown_cont_drdv_down"></div>
            </div>
          </div>
        </div>
      </div>-->

      <div class="arrecredifooter_view">
        <div class="arrecredifooter_vleft">
          <div class="arrecredifooter_vltext">Ten la vida que deseas con Arrecredi</div>
          <div class="arrecredifooter_vlgoogleplay">
            <img src="../assets/img/google_link_1.webp" alt="">
          </div>
          <div class="arrecredifooter_vlcopyright"></div>
        </div>
        <div class="arrecredifooter_vright">
          <div class="arrecredifooter_vrtov">
            <div class="arrecredifooter_vrtleft">
              <div class="footer_contact_view" style="padding-bottom: 40px;">
                <div class="footer_contact_top">Teléfono:</div>
                <div class="footer_contact_down">5594484815</div>
              </div>
              <div class="footer_contact_view" style="padding-bottom: 40px;">
                <div class="footer_contact_top">Correo:</div>
                <div class="footer_contact_down"></div>
              </div>
              <div class="footer_contact_view" style="padding-bottom: 40px;">
                <div class="footer_contact_top">Horario:</div>
                <div class="footer_contact_down">Lunes a viernes 9:00-18.30,</div>
                <div class="footer_contact_down">Sábado y domingo 9.00-14.30.</div>
              </div>
              <div class="footer_contact_view" style="padding-bottom: 48px;">
                <div class="footer_contact_top">Nombre de empresa</div>
                <div class="footer_contact_down">YOONATECH, S.A. DE C.V.</div>
              </div>
            </div>
            <div class="arrecredifooter_vrtright">
              <div class="arrecredifooter_vrtlink" @click.stop="goLink('second')">Términos y Condiciones</div>
              <div class="arrecredifooter_vrtlink" @click.stop="goLink('first')">Aviso de Privacidad</div>
              <div class="footer_contact_top" style="margin-top: 50px;">Redes sociales</div>
              <div class="arrecredifooter_vrdonev">
                <a
                        href="https://www.facebook.com/profile.php?id=61584689903622"
                        target="_blank"
                        class="playBtn"
                >
                <div class="arrecredifooter_vrdmg">
                  <img src="../assets/img/facebook.webp" alt="">
                </div>
                </a>
                <a
                        href="https://www.instagram.com/arrecredi_atc/"
                        target="_blank"
                        class="playBtn"
                >
                <div class="arrecredifooter_vrdmg">
                  <img src="../assets/img/instagram.webp" alt="">
                </div>
                </a>
              </div>
              <div class="arrecredifooter_vrdonev">
                <a
                        href="https://www.tiktok.com/@arrecredi.app_mex?_r=1&_t=ZS-91fsHvrtuUu"
                        target="_blank"
                        class="playBtn"
                >
                <div class="arrecredifooter_vrdmg">
                  <img src="../assets/img/tiktok.webp" alt="">
                </div>
                </a>
                <a
                        href="https://youtube.com/@arrecredimexico?si=WNbtmpRW59UeTuPu"
                        target="_blank"
                        class="playBtn"
                >
                <div class="arrecredifooter_vrdmg">
                  <img src="../assets/img/youtube.webp" alt="">
                </div>
                </a>
              </div>
            </div>
          </div>
          <!--<div class="arrecredifooter_vrdon">
            <div class="arrecredifooter_vrdonev">
              <div class="arrecredifooter_vrdmg">
                <img src="../assets/img/arrecredifooter_vrdmg_4.webp" alt="">
              </div>
              <div class="arrecredifooter_vrdmg">
                <img src="../assets/img/arrecredifooter_vrdmg_5.webp" alt="">
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </div>
    <div class="footer_arrecredi_1v_copyrit">
      <span>Todos los derechos reservados © 2025 YOONATECH, S.A. DE C.V.</span>
    </div>
  </div>
</template>

<script>
import "./scss/foot.scss";

export default {
  name: "footPage",
  data() {
    return {};
  },
  methods: {
    goFacebook() {
      window.location.href = 'https://www.facebook.com/profile.php?id=61576050817729';
    },
    goInstagram() {
      window.location.href = 'https://www.instagram.com/arrecredi_atc/'
    },
    openGooglePlayLink() {
      //console.log('googleplay')
      window.location.href = 'https://app.adjust.com/1o8iv5h7';
    },
    goLink(type) {
      this.$router.push({
        path: '/loan',
        query: {
          activeName: type
        }
      })
    }
  }
};
</script>
